import { useMutation } from "@tanstack/react-query";
import type { ImpersonationStopResponse } from "@mfa-aff/shared";
import { endMockAdminView } from "../mocks/admin-view";
import { meMock } from "../mocks/me";
import { send } from "./client";
import { USE_MOCKS } from "./config";
import { rememberImpersonation, safeAdminUrl } from "./impersonation-state";
import { partnerPaths } from "./paths";

/** Admin panel in mock mode (dev); in production it is on this same host under /admin/. */
const ADMIN_DEV_URL: string = import.meta.env.VITE_ADMIN_DEV_URL ?? "http://localhost:5174";

/** `POST auth/impersonate/stop`: ends the admin's read-only view (cookies cleared, history row written). */
export const useStopImpersonation = () =>
    useMutation({
        mutationFn: () =>
            send<ImpersonationStopResponse>("POST", partnerPaths.impersonateStop, undefined, () => {
                endMockAdminView();
                return { adminUrl: `/admin/partners/${meMock.affiliate.id}` };
            }),
        // The bar leaves for the admin panel whatever the answer: no error toast.
        meta: { silent: true },
    });

/** Goes to the partner's page in the admin panel: only that page, whatever the server or storage says. */
export function leaveToAdmin(...candidates: (string | null | undefined)[]): void {
    rememberImpersonation(null);
    const target = candidates.map(safeAdminUrl).find((u): u is string => u !== null) ?? "/admin/partners";
    window.location.assign(USE_MOCKS ? `${ADMIN_DEV_URL}${target}` : target);
}
